'use strict';

exports = module.exports = require('./lib/parser')['default'];
exports['default'] = exports;



/*****************
 ** WEBPACK FOOTER
 ** /jobvolume/donatenodeweb-ci-9488/workspace/Release/~/intl-messageformat-parser/index.js
 ** module id = 195
 ** module chunks = 0 1 2 3 4 5 6
 **/